import { render, staticRenderFns } from "./AmexSvg.vue?vue&type=template&id=2eed96d0&scoped=true&"
import script from "./AmexSvg.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AmexSvg.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eed96d0",
  null
  
)

export default component.exports